<img
  [id]="tooltipTriggerElementId"
  [src]="triggerIcon"
  role="button"
  tabindex="0"
  class="self-center justify-self-center relative grayscale-effect"
/>
<div [id]="tooltipElementId" class="tooltip">
  <ng-container [ngTemplateOutlet]="tooltipTemplate"></ng-container>
</div>

<ng-template #tooltipTemplate>
  <div
    class="info-tooltip-content__container grid grid-cols-[80%_20%] gap-[8px]"
  >
    <div class="info-tooltip-content__container__body">
      <div
        *ngIf="infoModalContent.title"
        class="info-tooltip-content__container__title text-label-xs-semibold"
        [innerHTML]="infoModalContent.title"
      ></div>
      <div
        *ngIf="infoModalContent.description"
        class="info-tooltip-content__container__desc"
        [innerHTML]="infoModalContent.description"
      ></div>
    </div>
    <img
      class="cursor-pointer justify-self-end"
      (click)="handleTooltipCloseIconClick()"
      role="button"
      tabindex="0"
      (keydown.enter)="handleTooltipCloseIconClick()"
      src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/close-white-icon.svg"
    />
  </div>
</ng-template>
